import { isSuccessApiStatusCode } from "@/api/handler";
import { profileEntity } from "@/models/modules/profile/entity";
import api from '../index';
import { getFormDataByObj } from "@/api/other-request-handler";
import {
	IUploadPayrollFile,
	IGetPayrollTemplatesParams,
	IPayrollData,
	EPayrollPaymentType,
	IPayrollEmployee,
	IPayrollTemplateForDownload,
	IPayrollTemplateUpdateData,
	IPayrollTemplateUpdatedData,
	PayrollSendToDirectorData,
	IPayrollMass,
	IPayrollMassResponse
} from "@/api/payroll/interface";
import { IApiHandlerParams } from "@/api/interface";
import { PayrollDraftSaveData } from './interface';

export const $getAccountsByTypeListPayroll = async (
	data?: any
): Promise<Array<any>> => {
	// return require('./mock/account-list.json').data;

	return api
		.post("payroll/get-history", data)
		.then(r => r || null);
};

export const $getPayrollList = ( status: string = 'DRAFT', handler?: IApiHandlerParams): Promise<IPayrollData[]> => api
		.get('payroll/list', { request: { params: { status } }, handler })
		.then(r => r || []);

export const $getPayrollTemplatesList = (params: IGetPayrollTemplatesParams): Promise<any[]> => api
	.get('payroll/template/list', { request: { params } })
	.then(r => r || []);

export const $downloadPayrollTemplate = (payrollId: number): Promise<string> => api
	.get(`payroll/${payrollId}/file-template`)
	.then((r: IPayrollTemplateForDownload) => (r && r.message) || '');

export const $downloadPayrollTemplateByType = (payrollType: string): Promise<string> => api
	.get(`payroll/file-template/${payrollType}`)
	.then((r: IPayrollTemplateForDownload) => (r && r.message) || '');

export const $getPayrollEmployee = (payrollId: number): Promise<IPayrollEmployee[]> => api
	.get('payroll/get-employee', { request: { params: { payrollId } } })
	.then(r => r || []);

export const $getPayrollAddedEmployee = (payrollId: number): Promise<IPayrollEmployee[]> => api
	.get(`payroll/${payrollId}/employee/list`)
	.then(r => (r && r.employees) || []);

export const $getPayrollDocNumber = async (v?: any): Promise<Array<any>> => {
	return api
		.get("cbs/last-doc-number", v)
		.then(r => r || []);
	}

export const $addPayrollEmployee = (payrollId: number, v: IPayrollEmployee): Promise<number> => api
	.post(`payroll/${payrollId}/employee`, v)
	.then((r: IPayrollEmployee) => (r && r.employeeId) || 0);

export const $addPayrollEmployeeMass = (v: IPayrollMass): Promise<IPayrollMassResponse> => api
	.post('payroll/employee-mass', v)
	.then(r => r)

export const $rejectPayrollEmployeeMass = (v: IPayrollMass): Promise<IPayrollMassResponse> => api
	.post('payroll/reject-employee-mass', v)
	.then(r => r)

export const $updatePayrollAddedEmployee = (
	payrollId: number,
	employeeId: number,
	paymentAmount: number
): Promise<boolean> => api
	.put(
		`payroll/${payrollId}/employee/${employeeId}`,
		{ paymentAmount },
		{ handler: { returnData: false } }
	)
	.then(r => r && isSuccessApiStatusCode(r.status));

export const $deletePayrollAddedEmployee = (payrollId: number, employeeId: number): Promise<boolean> => api
	.delete(`payroll/${payrollId}/employee/${employeeId}`, { handler: { returnData: false } })
	.then(r => r && isSuccessApiStatusCode(r.status));

export const $deletePayrollTemplate = (payrollId: number): Promise<boolean> => api
	.delete('payroll/template/id/' + payrollId, { handler: { returnData: false } })
	.then(r => r && isSuccessApiStatusCode(r.status));

export const $createPayrollFromTemplate = (payrollTemplateId: number, purpose: string): Promise<any> => api
	.post('payroll/create-from-template', { payrollTemplateId, purpose });

export const $createPayrollFromTemplateIfNotExist = (
	payrollTemplateId: number,
	purpose: string
): Promise<any> => $getPayrollList()
	.then(r => r.length
		? true
		: $createPayrollFromTemplate(payrollTemplateId, purpose));

export const $uploadPayrollFile = (v: IUploadPayrollFile, payrollId?: number): Promise<any[]> => api
	.post('payroll/file', getFormDataByObj(v), { request: { params: { payrollId } } })
	.then(r => r || []);

export const $uploadPayrollByTypeFile = (v: IUploadPayrollFile, payrollType: string): Promise<any[]> => api
	.post('payroll/upload-file', getFormDataByObj(v), { request: { params: { payrollType } } });

export const $createPayroll = async (payrollType: EPayrollPaymentType): Promise<number> => {
	// return require('./mock/payroll-create.json').data;

	return api
	.post('payroll/create', { payrollType })
	.then(r => r && r.payrollId);
}

export const $createPayrollTemplate = (idPayroll: number, name: string): Promise<number> => api
	.post('payroll/create-template', { idPayroll, name })
	.then((r: IPayrollTemplateUpdatedData) => (r && r.payrollTemplateId) || 0);

export const $updatePayrollTemplate = (v: IPayrollTemplateUpdateData): Promise<number> => api
	.put('payroll/update-template', v)
	.then((r: IPayrollTemplateUpdatedData) => (r && r.payrollTemplateId) || 0);

export const $sendPayrollToDirector = (
	payroll: PayrollSendToDirectorData
): Promise<boolean> => api
	.post('payroll/send-to-approve', payroll, {
		handler: { returnData: false }
	})
	.then(r => (r && isSuccessApiStatusCode(r.status)) || false);

export const $savePayrollToDraft = (
	{ payrollId, ...payroll }: PayrollDraftSaveData
): Promise<boolean> => api
	.put('payroll/' + payrollId, payroll, {
		handler: { returnData: false }
	})
	.then(r => r && isSuccessApiStatusCode(r.status));

export const $savePayrollToNewDraft = (
	{ ...payroll }: IPayrollData
): Promise<boolean> => api
	.post('payroll/save-draft', payroll, {
		handler: { returnData: false }
	})
	.then(r => r && isSuccessApiStatusCode(r.status));

export const $deletePayroll = (
	payrollId: number
): Promise<boolean> => api
	.post(
		`payroll/${payrollId}/delete-by-` +
			(profileEntity.profileData?.role === 'DIRECTOR' ? 'director' : 'author'),
		undefined,
		{ handler: { returnData: false } }
	)
	.then(r => r && isSuccessApiStatusCode(r.status));
